module.exports = __webpack_public_path__ + "img/tp100-login-logo.76f6a901.png";